import React from 'react';
import RootMutateSingleVoyage from "@containers/singleVoyage/mutateVoyage/RootMutateSingleVoyage";
import {IPositionSingleVoyage,} from "@containers/singleVoyage/types/position";
import {
    IWayPointCreationSingleVoyage,
    IWayPointCreationWithCorrectionsSingleVoyage
} from "@containers/singleVoyage/types/point";
import ViewContextProviderMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/context/viewContext/ViewContextProviderMutateSingleVoyage";
import MapFeaturesContextProvider from "@ui/leafletCustom/context/mapContext/MapFeaturesContextProvider";
import {IRouteInfoSingleVoyage} from "@containers/singleVoyage/types/route";
import RootContextProviderMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/context/rootContext/RootContextProviderMutateSingleVoyage";
import {ITaskCreationSingleVoyageMutateVoyage} from "@containers/singleVoyage/mutateVoyage/tasks/types";
import OnlyDesktopControlSingleVoyage
    from "@containers/singleVoyage/views/onlyDesktopControl/OnlyDesktopControlSingleVoyage";

interface IProps {
    initialPositions?: IPositionSingleVoyage[]
    initialPoints?: IWayPointCreationWithCorrectionsSingleVoyage[]
    initialRouteInfo?: IRouteInfoSingleVoyage
    initialTasks?: ITaskCreationSingleVoyageMutateVoyage[]
    voyageId?: number
    initialTasksLocalCreateIds?: number[]
}

const MutateSingleVoyage = ({
                                initialPositions,
                                initialPoints,
                                initialRouteInfo,
                                initialTasks,
                                voyageId,
                                initialTasksLocalCreateIds,
                            }: IProps) => {

    return (
        <OnlyDesktopControlSingleVoyage>
            <MapFeaturesContextProvider>
                <ViewContextProviderMutateSingleVoyage>
                    <RootContextProviderMutateSingleVoyage
                        initialPositions={initialPositions}
                        initialPoints={initialPoints}
                        initialRouteInfo={initialRouteInfo}
                        voyageId={voyageId}
                        initialTasks={initialTasks}
                        initialTasksLocalCreateIds={initialTasksLocalCreateIds}
                    >
                        <RootMutateSingleVoyage/>
                    </RootContextProviderMutateSingleVoyage>
                </ViewContextProviderMutateSingleVoyage>
            </MapFeaturesContextProvider>
        </OnlyDesktopControlSingleVoyage>
    );
};

export default MutateSingleVoyage;
